// ==============================================================================
// Story 005: The Midnight Secret (Old Storage Version - Cat on Head)
// Level: 1 (Middle School Year 1)
// Target: ~8-10 sentences per page, JHS1 Grammar (Present, Can, Progressive)
// ==============================================================================

const STORY_DATA = [
  {
    title: "Page 1: The Scary Teacher",
    rubyText: [
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "lunch", r: "ランチ" },
      { w: "time.", r: "タイム" , s: true},
      { w: "Mr.", r: "ミスター" },
      { w: "Onizuka", r: "オニヅカ" },
      { w: "walks", r: "ウォークス", s: true },
      { w: "by.", r: "バイ" , s: true},
      { w: "He", r: "ヒー" },
      { w: "looks", r: "ルックス" },
      { w: "very", r: "ベリー" },
      { w: "scary.", r: "スケアリー" , s: true},
      { w: "'I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "scared", r: "スケアード", s: true },
      { w: "of", r: "オブ" },
      { w: "him,'", r: "ヒム" , s: true},
      { w: "Ren", r: "レン" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "Miku", r: "ミク" },
      { w: "whispers,", r: "ウィスパーズ" , s: true},
      { w: "'Let's", r: "レッツ" },
      { w: "go", r: "ゴー" },
      { w: "to", r: "トゥ" },
      { w: "the", r: "ザ" },
      { w: "old", r: "オールド" },
      { w: "storage", r: "ストレージ" },
      { w: "house.", r: "ハウス" , s: true},
      { w: "There", r: "ゼア" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "ghost.'", r: "ゴースト" , s: true},
      { w: "'No", r: "ノー" },
      { w: "way!'", r: "ウェイ" , s: true},
      { w: "I", r: "アイ" },
      { w: "say,", r: "セイ", s: true },
      { w: "but", r: "バット" },
      { w: "we", r: "ウィー" },
      { w: "decide", r: "ディサイド" },
      { w: "to", r: "トゥ" },
      { w: "go.", r: "ゴー" , s: true},
    ],
    en: "It is lunch time. Mr. Onizuka walks by. He looks very scary. 'I am scared of him,' Ren says. Miku whispers, 'Let's go to the old storage house. There is a ghost.' 'No way!' I say, but we decide to go.",
    ja: "お昼の時間です。鬼塚先生が通りかかります。彼はとても怖そうに見えます。「彼、怖いよ」とレンが言います。ミクがささやきます。「古い倉庫に行こうよ。あそこにはオバケがいるの」「まさか！」と僕は言いますが、僕たちは行くことに決めます。",
    learning: {
      vocab: [
        { word: "whisper", mean: "ささやく" },
        { word: "storage", mean: "倉庫・保管場所" },
        { word: "decide", mean: "決める" },
      ],
      grammar: {
        title: "There is ...",
        desc: "「～がある」「～がいる」という存在を表す文です。",
        key: "There is a ghost.",
      },
    },
    color: "bg-slate-800",
    accent: "text-slate-300",
    mood: { rate: 1.0, pitch: 1.0 },
    image: "images/005/01.jpg",
    startTime: 0,
  },
  {
    title: "Page 2: Skeletons and Drums",
    rubyText: [
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "midnight.", r: "ミッドナイト" , s: true},
      { w: "We", r: "ウィー" },
      { w: "go", r: "ゴー" },
      { w: "inside", r: "インサイド" },
      { w: "the", r: "ザ" },
      { w: "storage", r: "ストレージ" },
      { w: "house.", r: "ハウス" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "full", r: "フル", s: true },
      { w: "of", r: "オブ" },
      { w: "old", r: "オールド" },
      { w: "things.", r: "シングス" , s: true},
      { w: "I", r: "アイ" },
      { w: "see", r: "シー" },
      { w: "a", r: "ア" },
      { w: "science", r: "サイエンス" },
      { w: "model.", r: "モデル" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "skeleton!", r: "スケルトン" , s: true},
      { w: "'Scary...'", r: "スケアリー", s: true },
      { w: "Ren", r: "レン" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "I", r: "アイ" },
      { w: "also", r: "オルソー" },
      { w: "see", r: "シー" },
      { w: "old", r: "オールド" },
      { w: "music", r: "ミュージック" },
      { w: "instruments.", r: "インストゥルメンツ" , s: true},
      { w: "There", r: "ゼア" },
      { w: "are", r: "アー" },
      { w: "big", r: "ビッグ" },
      { w: "drums", r: "ドラムス", s: true },
      { w: "and", r: "アンド" },
      { w: "a", r: "ア" },
      { w: "broken", r: "ブロークン" },
      { w: "piano.", r: "ピアノ" , s: true},
    ],
    en: "It is midnight. We go inside the storage house. It is full of old things. I see a science model. It is a skeleton! 'Scary...' Ren says. I also see old music instruments. There are big drums and a broken piano.",
    ja: "真夜中です。僕たちは倉庫の中に入ります。古い物でいっぱいです。理科の模型が見えます。ガイコツです！「怖い……」レンが言います。古い楽器も見えます。大きな太鼓や、壊れたピアノがあります。",
    learning: {
      vocab: [
        { word: "full of", mean: "～でいっぱいの" },
        { word: "skeleton", mean: "骸骨" },
        { word: "instrument", mean: "楽器" },
      ],
      grammar: {
        title: "There are ...",
        desc: "「～がある」の複数形です。後ろに来る名詞が複数の場合に使います。",
        key: "There are big drums.",
      },
    },
    color: "bg-stone-900",
    accent: "text-stone-400",
    mood: { rate: 0.9, pitch: 0.9 },
    image: "images/005/02.jpg",
    startTime: 20,
  },
  {
    title: "Page 3: The Demon Shadow",
    rubyText: [
      { w: "Suddenly,", r: "サドゥンリー", s: true },
      { w: "we", r: "ウィー" },
      { w: "hear", r: "ヒア" },
      { w: "a", r: "ア" },
      { w: "sound.", r: "サウンド" , s: true},
      { w: "Dong,", r: "ドーン" , s: true},
      { w: "dong.", r: "ドーン" , s: true},
      { w: "'Is", r: "イズ" },
      { w: "that", r: "ザット" },
      { w: "the", r: "ザ" },
      { w: "piano?'", r: "ピアノ", s: true },
      { w: "Miku", r: "ミク" },
      { w: "asks.", r: "アスクス" , s: true},
      { w: "Then,", r: "ゼン" , s: true},
      { w: "we", r: "ウィー" },
      { w: "see", r: "シー" },
      { w: "a", r: "ア" },
      { w: "blue", r: "ブルー" },
      { w: "light.", r: "ライト" , s: true},
      { w: "It", r: "イット" },
      { w: "moves", r: "ムーブス" },
      { w: "near", r: "ニア" },
      { w: "the", r: "ザ" },
      { w: "drums.", r: "ドラムス" , s: true},
      { w: "A", r: "ア" },
      { w: "tall", r: "トール" },
      { w: "shadow", r: "シャドウ" },
      { w: "stands", r: "スタンズ", s: true },
      { w: "there.", r: "ゼア" , s: true},
      { w: "'Look!'", r: "ルック", s: true },
      { w: "Ren", r: "レン" },
      { w: "cries.", r: "クライズ" , s: true},
      { w: "'It", r: "イット" },
      { w: "has", r: "ハズ" },
      { w: "two", r: "トゥー" },
      { w: "horns!", r: "ホーンズ" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "demon!'", r: "デーモン" , s: true},
    ],
    en: "Suddenly, we hear a sound. Dong, dong. 'Is that the piano?' Miku asks. Then, we see a blue light. It moves near the drums. A tall shadow stands there. 'Look!' Ren cries. 'It has two horns! It is a demon!'",
    ja: "突然、音が聞こえます。ドーン、ドーン。「ピアノの音？」ミクが聞きます。その時、青い光が見えます。太鼓の近くで動いています。そこに背の高い影が立っています。「見て！」レンが叫びます。「角が２本ある！ 鬼だ！」",
    learning: {
      vocab: [
        { word: "horn", mean: "角（ツノ）" },
        { word: "demon", mean: "鬼・悪魔" },
        { word: "stand", mean: "立つ" },
      ],
      grammar: {
        title: "hear + 音",
        desc: "「～という音が聞こえる」という表現です。hear a sound で「音がする」。",
        key: "We hear a sound.",
      },
    },
    color: "bg-indigo-900",
    accent: "text-indigo-200",
    mood: { rate: 1.0, pitch: 1.1 },
    image: "images/005/03.jpg",
    startTime: 40,
  },
  {
    title: "Page 4: Trapped!",
    rubyText: [
      { w: "The", r: "ザ" },
      { w: "demon", r: "デーモン" },
      { w: "comes", r: "カムズ" },
      { w: "to", r: "トゥ" },
      { w: "us.", r: "アス" , s: true},
      { w: "We", r: "ウィー" },
      { w: "run", r: "ラン" },
      { w: "to", r: "トゥ" },
      { w: "the", r: "ザ" },
      { w: "corner.", r: "コーナー" , s: true},
      { w: "We", r: "ウィー" },
      { w: "are", r: "アー" },
      { w: "behind", r: "ビハインド" },
      { w: "the", r: "ザ" },
      { w: "big", r: "ビッグ" },
      { w: "drums.", r: "ドラムス" , s: true},
      { w: "We", r: "ウィー" },
      { w: "cannot", r: "キャノット" },
      { w: "escape.", r: "エスケープ" , s: true},
      { w: "'I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "so", r: "ソー" },
      { w: "scared,'", r: "スケアード", s: true },
      { w: "Ren", r: "レン" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "'Use", r: "ユーズ" },
      { w: "the", r: "ザ" },
      { w: "flashlight!'", r: "フラッシュライト", s: true },
      { w: "Miku", r: "ミク" },
      { w: "shouts.", r: "シャウツ" , s: true},
      { w: "We", r: "ウィー" },
      { w: "shine", r: "シャイン" },
      { w: "the", r: "ザ" },
      { w: "light", r: "ライト", s: true },
      { w: "on", r: "オン" },
      { w: "the", r: "ザ" },
      { w: "ghost.", r: "ゴースト" , s: true},
    ],
    en: "The demon comes to us. We run to the corner. We are behind the big drums. We cannot escape. 'I am so scared,' Ren says. 'Use the flashlight!' Miku shouts. We shine the light on the ghost.",
    ja: "鬼が僕たちの方に来ます。僕たちは隅っこに走ります。大きな太鼓の後ろです。逃げられません。「すごく怖いよ」とレンが言います。「懐中電灯を使って！」ミクが叫びます。僕たちは光をオバケに浴びせます。",
    learning: {
      vocab: [
        { word: "behind", mean: "～の後ろに" },
        { word: "escape", mean: "逃げる" },
        { word: "shine", mean: "照らす" },
      ],
      grammar: {
        title: "cannot (can't)",
        desc: "「～できない」という不可能を表す助動詞です。",
        key: "We cannot escape.",
      },
    },
    color: "bg-red-900",
    accent: "text-red-200",
    mood: { rate: 1.1, pitch: 1.2 },
    image: "images/005/04.jpg",
    startTime: 60,
  },
  {
    title: "Page 5: The Teacher's Face",
    rubyText: [
      { w: "The", r: "ザ" },
      { w: "ghost", r: "ゴースト" },
      { w: "stops.", r: "ストップス" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "Mr.", r: "ミスター" },
      { w: "Onizuka!", r: "オニヅカ" , s: true},
      { w: "A", r: "ア" },
      { w: "black", r: "ブラック" },
      { w: "cat", r: "キャット" },
      { w: "is", r: "イズ" },
      { w: "on", r: "オン" },
      { w: "his", r: "ヒズ" },
      { w: "head.", r: "ヘッド" , s: true},
      { w: "'Mr.", r: "ミスター" },
      { w: "Onizuka?'", r: "オニヅカ", s: true },
      { w: "we", r: "ウィー" },
      { w: "shout.", r: "シャウト" , s: true},
      { w: "The", r: "ザ" },
      { w: "cat's", r: "キャッツ" },
      { w: "ears", r: "イヤーズ" },
      { w: "look", r: "ルック" },
      { w: "like", r: "ライク" },
      { w: "horns.", r: "ホーンズ" , s: true},
      { w: "His", r: "ヒズ" },
      { w: "face", r: "フェイス" },
      { w: "turns", r: "ターンズ" },
      { w: "red.", r: "レッド" , s: true},
      { w: "'What", r: "ホワット" },
      { w: "are", r: "アー" },
      { w: "you", r: "ユー" },
      { w: "doing", r: "ドゥーイング" },
      { w: "here?'", r: "ヒア", s: true },
      { w: "he", r: "ヒー" },
      { w: "asks.", r: "アスクス" , s: true},
      { w: "The", r: "ザ" },
      { w: "cat", r: "キャット" },
      { w: "says,", r: "セイズ" , s: true},
      { w: "'Meow.'", r: "ミャオ" , s: true},
    ],
    en: "The ghost stops. It is Mr. Onizuka! A black cat is on his head. 'Mr. Onizuka?' we shout. The cat's ears look like horns. His face turns red. 'What are you doing here?' he asks. The cat says, 'Meow.'",
    ja: "オバケは止まります。なんと鬼塚先生です！ 黒猫が彼の頭に乗っています。「鬼塚先生？」僕たちは叫びます。猫の耳が角のように見えます。先生の顔が赤くなります。「お前たち、ここで何をしている？」彼が聞きます。猫が「ニャー」と鳴きます。",
    learning: {
      vocab: [
        { word: "ear", mean: "耳" },
        { word: "turn red", mean: "（顔が）赤くなる" },
        { word: "horn", mean: "角" },
      ],
      grammar: {
        title: "look like ...",
        desc: "「～のように見える」という表現です。look like horns で「角のように見える」。",
        key: "The ears look like horns.",
      },
    },
    color: "bg-emerald-900",
    accent: "text-emerald-200",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/005/05.jpg",
    startTime: 80,
  },
  {
    title: "Page 6: The Cats' Concert",
    rubyText: [
      { w: "We", r: "ウィー" },
      { w: "look", r: "ルック" },
      { w: "around.", r: "アラウンド" , s: true},
      { w: "We", r: "ウィー" },
      { w: "see", r: "シー" },
      { w: "many", r: "メニー" },
      { w: "cats.", r: "キャッツ" , s: true},
      { w: "They", r: "ゼイ" },
      { w: "are", r: "アー" },
      { w: "sleeping", r: "スリーピング", s: true },
      { w: "in", r: "イン" },
      { w: "guitar", r: "ギター" },
      { w: "cases", r: "ケーシズ", s: true },
      { w: "and", r: "アンド" },
      { w: "drums.", r: "ドラムス" , s: true},
      { w: "Mr.", r: "ミスター" },
      { w: "Onizuka", r: "オニヅカ" },
      { w: "smiles.", r: "スマイルズ" , s: true},
      { w: "'They", r: "ゼイ" },
      { w: "have", r: "ハブ" },
      { w: "no", r: "ノー" },
      { w: "home,'", r: "ホーム", s: true },
      { w: "he", r: "ヒー" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "'Please", r: "プリーズ" },
      { w: "keep", r: "キープ" },
      { w: "this", r: "ディス" },
      { w: "secret.'", r: "シークレット" , s: true},
      { w: "'We", r: "ウィー" },
      { w: "promise,'", r: "プロミス", s: true },
      { w: "we", r: "ウィー" },
      { w: "say.", r: "セイ" , s: true},
      { w: "The", r: "ザ" },
      { w: "next", r: "ネクスト" },
      { w: "day,", r: "デイ", s: true },
      { w: "we", r: "ウィー" },
      { w: "bring", r: "ブリング" },
      { w: "cat", r: "キャット" },
      { w: "food.", r: "フード" , s: true},
    ],
    en: "We look around. We see many cats. They are sleeping in guitar cases and drums. Mr. Onizuka smiles. 'They have no home,' he says. 'Please keep this secret.' 'We promise,' we say. The next day, we bring cat food.",
    ja: "僕たちは周りを見渡します。たくさんの猫がいます。猫たちはギターケースや太鼓の中で眠っています。鬼塚先生は微笑みます。「この子たちには家がないんだ」と彼は言います。「秘密にしてくれよ」「約束します」僕たちは言います。翌日、僕たちはキャットフードを持ってきます。",
    learning: {
      vocab: [
        { word: "around", mean: "周りを" },
        { word: "guitar case", mean: "ギターケース" },
        { word: "promise", mean: "約束する" },
      ],
      grammar: {
        title: "Prepositions (in)",
        desc: "「～の中に」を表す前置詞 in です。in guitar cases で「ギターケースの中に」となります。",
        key: "Sleeping in guitar cases.",
      },
    },
    color: "bg-orange-100",
    accent: "text-orange-800",
    mood: { rate: 1.0, pitch: 1.0 },
    image: "images/005/06.jpg",
    startTime: 100,
  },
];

const QUIZ_POOL = [
  {
    q: "Who is the scary teacher?",
    options: ["Mr. Sato", "Mr. Tanaka", "Mr. Onizuka"],
    a: 2,
    exp: "Page 1で「Mr. Onizuka walks by」とあります。",
  },
  {
    q: "Where do they decide to go?",
    options: ["To the old storage house", "To the library", "To the park"],
    a: 0,
    exp: "Page 1で「Let's go to the old storage house」と提案しています。",
  },
  {
    q: "What does Ren feel in Page 1?",
    options: ["He is happy", "He is scared", "He is hungry"],
    a: 1,
    exp: "Page 1で「I am scared of him」と言っています。",
  },
  {
    q: "What time do they go to the storage house?",
    options: ["At lunch", "In the morning", "At midnight"],
    a: 2,
    exp: "Page 2で「It is midnight」とあります。",
  },
  {
    q: "What science model do they see?",
    options: ["A robot", "A skeleton", "A dinosaur"],
    a: 1,
    exp: "Page 2で「It is a skeleton!」とあります。",
  },
  {
    q: "What music instruments are there?",
    options: ["Violins and flutes", "Drums and a piano", "Guitars only"],
    a: 1,
    exp: "Page 2で「big drums and a broken piano」とあります。",
  },
  {
    q: "What sound do they hear in Page 3?",
    options: ["Dong, dong", "Meow, meow", "Bang, bang"],
    a: 0,
    exp: "Page 3で「Dong, dong」という音が聞こえます。",
  },
  {
    q: "What do they see near the drums?",
    options: ["A red fire", "A blue light", "A black cat"],
    a: 1,
    exp: "Page 3で「we see a blue light」とあります。",
  },
  {
    q: "What does the shadow look like?",
    options: ["A demon with horns", "A dancing robot", "A small bird"],
    a: 0,
    exp: "Page 3で「It has two horns! It is a demon!」とあります。",
  },
  {
    q: "Where do they hide?",
    options: ["Under the table", "Behind the big drums", "In the box"],
    a: 1,
    exp: "Page 4で「We are behind the big drums」とあります。",
  },
  {
    q: "What does Miku use to fight?",
    options: ["A bat", "A flashlight", "A book"],
    a: 1,
    exp: "Page 4で「Use the flashlight!」と言っています。",
  },
  {
    q: "Who is the ghost?",
    options: ["A monster", "Mr. Onizuka", "A student"],
    a: 1,
    exp: "Page 5で「It is Mr. Onizuka!」とわかります。",
  },
  {
    q: "Where is the cat?",
    options: ["In his bag", "On his head", "Under his feet"],
    a: 1,
    exp: "Page 5で「A black cat is on his head」とあります。",
  },
  {
    q: "What looked like horns?",
    options: ["The cat's ears", "Two sticks", "The teacher's hair"],
    a: 0,
    exp: "Page 5で「The cat's ears look like horns」とあります。",
  },
  {
    q: "Why is Mr. Onizuka there?",
    options: ["To scare students", "To practice music", "To take care of cats"],
    a: 2,
    exp: "Page 6で猫の世話をしていることがわかります。",
  },
  {
    q: "Where are the cats sleeping?",
    options: ["In beds", "In guitar cases and drums", "On the floor"],
    a: 1,
    exp: "Page 6で「sleeping in guitar cases and drums」とあります。",
  },
  {
    q: "Why are the cats there?",
    options: ["They like music", "They have no home", "They are ghosts"],
    a: 1,
    exp: "Page 6で「They have no home」と先生が言っています。",
  },
  {
    q: "What does Mr. Onizuka ask?",
    options: ["Go away", "Keep this secret", "Study hard"],
    a: 1,
    exp: "Page 6で「Please keep this secret」と頼んでいます。",
  },
  {
    q: "What do the students bring the next day?",
    options: ["Music instruments", "Cat food", "Homework"],
    a: 1,
    exp: "Page 6で「We bring cat food」とあります。",
  },
  {
    q: "What is the story about?",
    options: [
      "A scary ghost",
      "A music concert",
      "A teacher's secret kindness",
    ],
    a: 2,
    exp: "怖い先生の意外な優しさを知る物語です。",
  },
];

const SCRAMBLE_POOL = [
  {
    q: "鬼塚先生が通りかかります。",
    w: ["Mr.", "Onizuka", "walks", "by"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼はとても怖そうに見えます。",
    w: ["He", "looks", "very", "scary"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私は彼が怖いです。",
    w: ["I", "am", "scared", "of", "him"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "古い倉庫に行きましょう。",
    w: ["Let's", "go", "to", "the", "old", "storage", "house"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "あそこにはオバケがいます。",
    w: ["There", "is", "a", "ghost"],
    o: [0, 1, 2, 3],
  },
  {
    q: "それは古い物でいっぱいです。",
    w: ["It", "is", "full", "of", "old", "things"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "理科の模型が見えます。",
    w: ["I", "see", "a", "science", "model"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "それはガイコツです！",
    w: ["It", "is", "a", "skeleton"],
    o: [0, 1, 2, 3],
  },
  {
    q: "壊れたピアノがあります。",
    w: ["There", "is", "a", "broken", "piano"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "私たちは音を聞きます。",
    w: ["We", "hear", "a", "sound"],
    o: [0, 1, 2, 3],
  },
  {
    q: "それはピアノですか？",
    w: ["Is", "that", "the", "piano"],
    o: [0, 1, 2, 3],
  },
  {
    q: "青い光が見えます。",
    w: ["We", "see", "a", "blue", "light"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "背の高い影がそこに立っています。",
    w: ["A", "tall", "shadow", "stands", "there"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "それには２本の角があります！",
    w: ["It", "has", "two", "horns"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私たちは逃げることができません。",
    w: ["We", "cannot", "escape"],
    o: [0, 1, 2],
  },
  {
    q: "懐中電灯を使って！",
    w: ["Use", "the", "flashlight"],
    o: [0, 1, 2],
  },
  {
    q: "黒猫が彼の頭に乗っています。",
    w: ["A", "black", "cat", "is", "on", "his", "head"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "猫の耳が角のように見えます。",
    w: ["The", "cat's", "ears", "look", "like", "horns"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "彼らには家がありません。",
    w: ["They", "have", "no", "home"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私たちはキャットフードを持ってきます。",
    w: ["We", "bring", "cat", "food"],
    o: [0, 1, 2, 3],
  },
];

const FILL_IN_THE_BLANK_POOL = [
  {
    q: "Mr. Onizuka looks _______.",
    options: ["scary", "scare", "scaring", "scared"],
    a: 0,
    exp: "look + 形容詞で「～に見える」です。scary（恐ろしい）が正解。",
  },
  {
    q: "I am scared _______ him.",
    options: ["of", "for", "at", "with"],
    a: 0,
    exp: "be scared of ... で「～が怖い」です。",
  },
  {
    q: "Let's _______ to the storage house.",
    options: ["go", "going", "goes", "went"],
    a: 0,
    exp: "Let's の後ろは動詞の原形です。",
  },
  {
    q: "It is full _______ old things.",
    options: ["of", "off", "on", "in"],
    a: 0,
    exp: "be full of ... で「～でいっぱいである」です。",
  },
  {
    q: "There _______ big drums.",
    options: ["are", "is", "am", "be"],
    a: 0,
    exp: "drums（複数）があるので are を使います。",
  },
  {
    q: "We _______ a sound.",
    options: ["hear", "hears", "hearing", "heard"],
    a: 0,
    exp: "主語 We なので動詞は原形 hear です。",
  },
  {
    q: "It _______ near the drums.",
    options: ["moves", "move", "moving", "moved"],
    a: 0,
    exp: "主語 It（三人称単数）なので三単現の s がつきます。",
  },
  {
    q: "It has _______ horns!",
    options: ["two", "to", "too", "tow"],
    a: 0,
    exp: "「2本の角」なので two が正解です。",
  },
  {
    q: "We are _______ the big drums.",
    options: ["behind", "front", "next", "to"],
    a: 0,
    exp: "behind（～の後ろに）が文脈に合います。",
  },
  {
    q: "We _______ escape.",
    options: ["cannot", "can", "do", "are"],
    a: 0,
    exp: "逃げられない状況なので cannot です。",
  },
  {
    q: "_______ the flashlight!",
    options: ["Use", "Uses", "Using", "To use"],
    a: 0,
    exp: "命令文は動詞の原形で始めます。",
  },
  {
    q: "A cat is _______ his head.",
    options: ["on", "in", "at", "to"],
    a: 0,
    exp: "「（頭の）上に」なので on を使います。",
  },
  {
    q: "The ears look _______ horns.",
    options: ["like", "as", "love", "likes"],
    a: 0,
    exp: "look like ... で「～のように見える」です。",
  },
  {
    q: "What are you _______ here?",
    options: ["doing", "do", "does", "did"],
    a: 0,
    exp: "現在進行形なので ing形 になります。",
  },
  {
    q: "They are sleeping _______ guitar cases.",
    options: ["in", "on", "at", "to"],
    a: 0,
    exp: "「（ケースの）中に」なので in を使います。",
  },
  {
    q: "Please _______ this secret.",
    options: ["keep", "keeps", "keeping", "to keep"],
    a: 0,
    exp: "命令文なので原形 keep を使います。",
  },
  {
    q: "We _______ promise!",
    options: ["promise", "promises", "promising", "promised"],
    a: 0,
    exp: "主語 We（複数）なので原形 promise です。",
  },
  {
    q: "We _______ cat food.",
    options: ["bring", "brings", "bringing", "brought"],
    a: 0,
    exp: "主語 We なので原形 bring です。",
  },
  {
    q: "There _______ a ghost.",
    options: ["is", "are", "am", "be"],
    a: 0,
    exp: "a ghost（単数）なので is を使います。",
  },
  {
    q: "Mr. Onizuka smiles _______.",
    options: ["shyly", "shy", "shyness", "shied"],
    a: 0,
    exp: "動詞 smiles を修飾する副詞 shyly（恥ずかしそうに）が入ります。",
  },
];

export default {
  id: "Jf9SRKsF",
  title: "The Midnight Secret",
  level: "LEVEL 1",
  category: "Suspense",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};

